export { default } from './FAQs';
